import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { heroShowcase } from "@/mocks/memes";

const hotTags = ["打工人", "早八", "周一", "评论区", "已读不回", "甲方"];

export default function HeroSection() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const goSearch = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    navigate(`/category/all?q=${encodeURIComponent(trimmed)}`);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    goSearch(keyword);
  };

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-b from-primary-50 to-background-50">
      <div className="pointer-events-none absolute -left-24 top-10 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-secondary-100/70 blur-3xl"></div>

      <div className="relative mx-auto grid w-full grid-cols-1 items-center gap-10 px-4 py-12 md:px-8 md:py-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1.5 text-xs text-primary-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-line text-sm"></i>
            </span>
            今日已整理 24 条新梗 · 持续更新
          </span>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
            131吃瓜
            <span className="mt-2 block text-2xl text-primary-600 md:text-3xl">最新梗都在这儿</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            梗图、表情包、神评论、网友二创一站式收齐。进来逛一圈，聊天里的梗能接住，配图也能顺手存走，不用再到处问最新周边。
          </p>

          <form onSubmit={handleSubmit} className="mt-7 flex w-full max-w-lg flex-col gap-3 sm:flex-row" role="search">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-3">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="试试搜「打工人」或「早八」"
                aria-label="站内搜索"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              找梗去
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <span className="text-sm text-foreground-500">热门标签</span>
            {hotTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => goSearch(tag)}
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="relative hidden h-[520px] lg:block">
          {heroShowcase.map((card, index) => {
            const positions = [
              "left-0 top-10 z-20 -rotate-6",
              "left-1/3 top-0 z-30 rotate-2",
              "right-0 top-24 z-10 rotate-6",
            ];
            return (
              <figure
                key={card.src}
                className={`absolute w-[46%] overflow-hidden rounded-lg border border-background-200 bg-background-50 ${positions[index]}`}
              >
                <div className="h-[300px] w-full overflow-hidden">
                  <img src={card.src} alt={card.alt} title="131吃瓜 热门梗图展示" className="h-full w-full object-cover" />
                </div>
                <figcaption className="flex items-center gap-2 px-4 py-3 text-sm text-foreground-800">
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-bookmark-3-line text-sm"></i>
                  </span>
                  {card.label}
                </figcaption>
              </figure>
            );
          })}
        </div>

        <div className="lg:hidden">
          <div className="w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="h-64 w-full overflow-hidden">
              <img
                src={heroShowcase[0].src}
                alt={heroShowcase[0].alt}
                title="131吃瓜 热门梗图展示"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}